// extracted by mini-css-extract-plugin
export default {"icon":"IconMessages_icon__eX-Rr","iconSelected":"IconMessages_iconSelected__wp0dT"};